import { ApiClient } from "../api.client";
import { GetMeResponse, GetPayoutsResponse, UpdateMeRequest, GetAcquiredUsersResponse } from "./types";

const AffiliateApi = {
  getMe() {
    return ApiClient.get<GetMeResponse>("/affiliates/me");
  },
  getPayouts() {
    return ApiClient.get<GetPayoutsResponse>(`/affiliates/payouts`);
  },
  updateMe(body: UpdateMeRequest) {
    return ApiClient.patch<UpdateMeRequest, UpdateMeRequest>(
      `/affiliates/me/update`,
      body
    );
  },
  getAcquiredUsers(page: number = 1, perPage: number = 5) {
    return ApiClient.get<GetAcquiredUsersResponse>(`/affiliates/acquired-users`, {
      params: {
        page,
        perPage
      },
    });
  },
};

export { AffiliateApi };
